
import { apiSlice } from '../Slices/apiSlice';

export const roleService = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAllRoles: builder.query({
            query: () => "/br-management/managed-br",
            providesTags: ['roles']
        }),

        getRoleById: builder.query({
            query: (id) => `/br-management/managed-br/${id}`,
            providesTags: ['roles']
        }),

        createRole: builder.mutation({
            query: (details) => ({
                url: '/br-management/managed-br',
                method: 'POST',
                body: details
            }),
            invalidatesTags: ['roles']
        }),

        updateRole: builder.mutation({
            query: (details) => ({
            url: `/br-management/managed-br`,
                method: "PUT",
                body: details,
            }),
            invalidatesTags: ["roles"],
        }),

        deleteRole: builder.mutation({
          query: (id) => ({
                url: `/br-management/managed-br/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["roles"],
        }),

    })
});

export const {
    useGetAllRolesQuery,
    useGetRoleByIdQuery,
    useCreateRoleMutation,
    useUpdateRoleMutation,
    useDeleteRoleMutation,
} = roleService;